import {
  Box,
  Users,
  Boxes,
  FileText,
  Activity,
  ClipboardCheck,
  Droplet,
  Warehouse,
  ScanLine,
  Package,
  Scale,
  FileSpreadsheet,
  Ship,
  QrCode,
  History,
  BarChart3,
  ListChecks,
  Container,
  TrendingUp,
  Settings,
} from "lucide-react";

// Category metadata (ordered). `color` drives the icon tile background.
export const SAFETY_CATEGORIES = [
  { key: "orders", label: "Orders & Customers", color: "#0f766e" },
  { key: "production", label: "Production", color: "#b45309" },
  { key: "inventory", label: "Inventory & Stock", color: "#1d4ed8" },
  { key: "dispatch", label: "Dispatch & Shipping", color: "#7c3aed" },
  { key: "admin", label: "Reports & Admin", color: "#334155" },
];

// Canonical Safety module registry. `perm: null` => always visible.
export const SAFETY_MODULES = [
  { key: "po", label: "PO Management", desc: "Upload, amend & track purchase orders.", icon: Box, cat: "orders", route: "/safety/po", perm: null },
  { key: "customers", label: "Customers", desc: "Customer master & contact details.", icon: Users, cat: "orders", route: "/safety/customers", perm: "customer.view" },
  { key: "catalog", label: "Product Catalog", desc: "SKUs, powders & specifications.", icon: Boxes, cat: "orders", route: "/safety/catalog", perm: "catalog.view" },

  { key: "production_reports", label: "Production Reports", desc: "Daily powder-coating output entry.", icon: FileText, cat: "production", route: "/safety/production-reports", perm: null },
  { key: "live_production", label: "Live Production", desc: "Real-time shift progress board.", icon: Activity, cat: "production", route: "/safety/production-live", perm: "production.view" },
  { key: "approvals", label: "Pending Approvals", desc: "Sign off submitted reports.", icon: ClipboardCheck, cat: "production", route: "/safety/production-reports/approvals", perm: "production.approve" },
  { key: "powder_masters", label: "Powder Masters", desc: "Powder batches & consumption.", icon: Droplet, cat: "production", route: "/safety/powder-masters", perm: "production.view" },

  { key: "inventory", label: "Inventory", desc: "Live stock by product & zone.", icon: Warehouse, cat: "inventory", route: "/safety/inventory", perm: "inventory.view" },
  { key: "stock_count", label: "Stock Count", desc: "Scan-driven physical count walks.", icon: ScanLine, cat: "inventory", route: "/safety/inventory/stock-count", perm: ["inventory.view", "stock.count"] },
  { key: "pallets", label: "Pallets", desc: "Pallet ledger & QR cards.", icon: Package, cat: "inventory", route: "/safety/pallets", perm: "pallet.view" },
  { key: "reconcile", label: "Reconcile", desc: "Variance vs ERP & cutover.", icon: Scale, cat: "inventory", route: "/safety/inventory/reconcile", perm: "inventory.view" },

  { key: "container_planner", label: "Container Planner", desc: "Plan PO loading into 40ft containers.", icon: Container, cat: "dispatch", route: "/safety/container-planner", perm: "container.plan" },

  { key: "packing_lists", label: "Packing Lists", desc: "Parse & manage packing lists.", icon: FileSpreadsheet, cat: "dispatch", route: "/safety/packing-lists", perm: "packing_list.view" },
  { key: "shipping_bills", label: "Shipping Bills", desc: "ICEGATE docs, gate-pass matching.", icon: Ship, cat: "dispatch", route: "/safety/shipping-bills", perm: "packing_list.view" },
  { key: "qr", label: "QR Generation", desc: "Print pallet QR batches.", icon: QrCode, cat: "dispatch", route: "/safety/qr", perm: null },
  { key: "qr_history", label: "QR History", desc: "Past QR batches & reprints.", icon: History, cat: "dispatch", route: "/safety/history", perm: null },

  { key: "management_report", label: "Management Report", desc: "KPIs & exportable summaries.", icon: BarChart3, cat: "admin", route: "/safety/management-report", perm: "management_report.view" },
  { key: "product_demand", label: "Product Demand", desc: "Products ranked most → least ordered.", icon: TrendingUp, cat: "admin", route: "/safety/product-demand", perm: "management_report.view" },
  { key: "audit", label: "Audit Trail", desc: "Every action, fully logged.", icon: ListChecks, cat: "admin", route: "/audit", perm: "audit.view" },
  { key: "qr_settings", label: "QR & System Settings", desc: "Templates & QR configuration.", icon: Settings, cat: "admin", route: "/safety/settings", perm: "qr.settings" },
];

export const MODULE_BY_KEY = SAFETY_MODULES.reduce((m, x) => { m[x.key] = x; return m; }, {});

export const catColor = (catKey) => (SAFETY_CATEGORIES.find((c) => c.key === catKey) || {}).color || "#334155";

// Which modules the user can actually reach.
export const accessibleModules = (perms) =>
  SAFETY_MODULES.filter((m) => {
    if (!m.perm) return true;
    const need = Array.isArray(m.perm) ? m.perm : [m.perm];
    return need.some((p) => (perms || []).includes(p));
  });
